<template>
<w-settings-content-template>
  <el-tabs slot="content" type="card" v-model="activeTab" @tab-click="onChangeMenu">
    <el-tab-pane label="관리대상 등록" name="WDeviceRegist" class="h100 w100">
      <w-device-regist ref="deviceRegist"></w-device-regist>
    </el-tab-pane>
    <el-tab-pane label="수집장비(RTU) 리스트" name="WRtuList" class="h100 w100">
      <w-rtu-list ref="rtuList"></w-rtu-list>
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WDeviceRegist from './DeviceRegist';
import WRtuList from './RtuList';

export default {
  name: 'WFacilityDevice',
  components: {
    WSettingsContentTemplate,
    WDeviceRegist,
    WRtuList,
  },
  data() {
    return {
      activeTab: 'WDeviceRegist',
    };
  },
  created() {
    this.$store.dispatch('loadAvailableSensorList');
  },
  methods: {
    onChangeMenu(menu) {
      if (menu.name === 'WDeviceRegist') {
        const deviceRegistCmp = this.$refs.deviceRegist;
        deviceRegistCmp.loadData();
        // RTU 리스트 재로드
        deviceRegistCmp.loadRtuList();
      } else {
        // this.$refs.deviceRegist.loadData();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/FacilityDevice/index.vue